import { useEffect } from 'react'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { CHUNK_RELOAD_SESSION_KEY, isChunkLoadError } from '@/lib/lazyWithRetry'

export function RouteErrorFallback() {
  const error = useRouteError()
  const chunkError = isChunkLoadError(error)

  useEffect(() => {
    if (!chunkError) {
      return
    }

    try {
      if (!sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY)) {
        sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, '1')
        window.location.reload()
      }
    } catch {
      window.location.reload()
    }
  }, [chunkError])

  const message = isRouteErrorResponse(error)
    ? error.statusText
    : error instanceof Error
      ? error.message
      : 'Something went wrong'

  if (chunkError) {
    return (
      <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 p-6 text-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary-500 border-t-transparent" />
        <p className="text-sm text-neutral-500">Loading latest version…</p>
      </div>
    )
  }

  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="font-display text-xl font-bold text-neutral-900">Something went wrong</h1>
      <p className="max-w-md text-sm text-neutral-500">{message}</p>
      <Button type="button" onClick={() => window.location.reload()}>
        Refresh page
      </Button>
    </div>
  )
}
